import React, {useState} from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/admin/Header';
import Sidebar from '../components/admin/Sidebar';
import Footer from '../components/admin/Footer';

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div className="App">
      <Sidebar sidebarOpen={sidebarOpen} />
      <div className={`dashboard-main ${!sidebarOpen ? 'active' : ''}`}>
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <div className="dashboard-main-body">
          <Outlet /> {/* Pages will render here */}
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default AdminLayout;
